import { useCallback, useMemo } from 'react';
import { TeamStatuses } from 'store/teams/types';
import { getTeamById } from 'store/teams/client';
import useDebounce from 'utils/useDebounce';
import FormSelect, { SelectOption } from '../formSelect/FormSelect';
import useTeams from 'hooks/useTeams';

type Props = {
    teamId: string | undefined;
    onChange: (id?: string) => void;
    onClear: () => void;
};

const TeamSelect = ({ teamId, onChange, onClear }: Props) => {
    const { teams, listTeams, entities } = useTeams();

    const fetchTeams = useCallback(
        (query?: string) => {
            listTeams(query ? { query, status: TeamStatuses.ACTIVE } : { size: 200, status: TeamStatuses.ACTIVE });
        },
        [listTeams]
    );

    const debouncedSearchTeams = useDebounce((q: string) => {
        fetchTeams(q?.trim() || undefined);
    }, 500);

    const selectOptions: SelectOption[] = useMemo(
        () =>
            teams.map((t) => ({
                id: t.id,
                value: t.name,
            })),
        [teams]
    );

    const displayValue = useMemo(() => {
        if (!teamId) return undefined;
        const customer = entities[teamId];

        if (!teamId) {
            getTeamById(teamId);
        }
        return customer?.name;
    }, [entities, teamId]);

    return (
        <FormSelect
            hideKeys
            placeholder="Select Team"
            onSearch={debouncedSearchTeams}
            onChange={(id) => {
                onChange(id);
                fetchTeams();
            }}
            selectOptions={selectOptions}
            onClear={() => {
                onClear();
                fetchTeams();
            }}
            value={displayValue}
        />
    );
};

export default TeamSelect;
